import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  TRADE_MARK_ROYAL,
  TRADE_MARK_CELEBRITY,
  TRADE_MARK
} from '../../configuration/terms'

const getTrademark = brandLetter => {
  let text = ''

  switch (brandLetter) {
    case 'R':
      text = TRADE_MARK_ROYAL
      break

    case 'C':
      text = TRADE_MARK_CELEBRITY
      break

    default:
      text = TRADE_MARK
  }

  return text
}

const TradeMark = props => {
  const brand = props?.activePackage?.brand
  const year = `&copy; ${moment().format('YYYY')}`
  let tradeMarkRaw = getTrademark(brand)
  const tradeMark = tradeMarkRaw.replaceAll('<year>', year)

  return <div dangerouslySetInnerHTML={{ __html: tradeMark }} />
}

const mapStateToProps = state => {
  const activePackage = state?.availablePackages[state?.activePackage] || {}

  return {
    activeSearchParameters: state?.activeSearchParameters,
    activePackage,
    ships: state?.ships
  }
}

export default connect(mapStateToProps)(TradeMark)
